import { Dot, Flex, Text } from '@bitrise/bitkit';
import { TypeMetricUnit } from '@trace/types';
import React, { FunctionComponent } from 'react';

import getFormattedValue from '../../../utils/metric/getFormattedValue';
import { colorScale3, scaleZero } from '../../ViewVisualisations/colorScales';

type Props = {
  unit: TypeMetricUnit;
  values: [string, number | null][];
};

const OverviewVersionTooltip: FunctionComponent<Props> = ({ values, unit }) => {
  return (
    <Flex direction="vertical" gap="x1">
      {values.map(([name, value], index, { length }) => (
        <Flex direction="horizontal" gap="x2" key={name}>
          <Flex grow direction="horizontal" gap="x1" alignChildrenVertical="middle">
            <Dot
              size="0.625rem"
              style={{ backgroundColor: colorScale3(scaleZero(index, length)) }}
            />
            <Text config="8">{name}</Text>
          </Flex>

          <Flex grow>
            <Flex
              direction="horizontal"
              alignChildrenVertical="middle"
              alignChildrenHorizontal="end"
            >
              <Text config="8">{getFormattedValue(unit, value)}</Text>
            </Flex>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default OverviewVersionTooltip;
